import useApi from '../../../services/useApi'
import {useContext} from 'react'
import {TicketDetailsContext} from '../context'

const useGetProjectMembers = () => {
  const Api = useApi()
  const {projectId} = useContext(TicketDetailsContext)
  const {data: response, isFetching} = Api.useGetQuery(`/agile/projects/${projectId}/members`)

  return {
    projectMembers: response?.data || [],
    isLoading: isFetching,
  }
}

export default useGetProjectMembers
